import FingerprintJS from './lib/fingerprintjs-v3-esm.js';
import Cookies from 'js-cookie';

const ad2udidValue = Cookies.get('ad2udid');
console.log('Cookie ad2udid:', ad2udidValue);
console.log('is in iframe:', window !== top.window);

function makeRequest(url) {
  return fetch(url)
    .then((res) => res.json())
    .catch((error) => {
      console.error('Aq2fp Request Error:', error);
    });
}

/**
 * 設定第一方 cookie (盡可能含所有上層網域)
 * @param {String} id ad2udid
 */
function setFirstPartyCookies(id) {
  // 只要 url 有帶 fp，回傳的 id 就不會是空的，故不再判斷 id !== ''
  const baseOption = {
    sameSite: 'None',
    secure: true,
    expires: 99999,
  };
  // 設定第一方 HostOnly cookie 值
  // 注意：如果這段 js 在 iframe 內的話此行形同無效 (ad2DSP 可以從 cmt.js@content 塞塞看，這段應該是 friendly frame)
  Cookies.set('ad2udid', id, baseOption);

  // 盡可能寫入所有頂層網域的 Cookies
  try {
    // const domainName = 'wwwcontent.ad2iction.com'; // fake domain
    const domainName = top.window.location.hostname;
    /*
      注意：在 safe frame 下不允許跨網域存取 window.location or window.document
      列出三種情況：
      1. 在沒有 iframe 的情況下，可正常呼叫 top.window.location.hostname。
      2. 在 iframe (friendly frame)，跨網域的情況下，可正常呼叫 top.window.location.hostname。
      3. 在 iframe (safe frame)，跨網域的情況下，呼叫 top.window.location.hostname 會報錯。
    */
    const domainParts = domainName.split('.');
    console.log('domainParts:', domainParts); // ex:[ "wwwcontent", "ad2iction", "com" ]
    // 這邊一開始不去掉陣列的第一個，盡可能含蓋所有 domain
    while (domainParts.length >= 2) {
      //往上層存取
      let domain = domainParts.join('.');
      console.log('domain:', domain);
      Cookies.set('ad2udid', id, {
        ...baseOption,
        domain,
      });
      domainParts.shift();
    }
  } catch (error) {
    console.error('Ad2fp In Safeframe:', error);
  }
}

/**
 * 設定第三方 cookie (透過 1px image)
 * @param {String} id ad2udid
 */
function setThirdPartyCookie(id) {
  let url = 'https://ads.ad2iction.com/html/cookit.php?fj=1&id=' + id;
  const img = document.createElement('img');
  img.src = url;
}

/**
 * 這是一個 Promise，使用 .then 可取得 ad2udid
 * @returns {Promise}
 */
function getAd2udid() {
  return new Promise((resolve, reject) => {
    const fpPromise = FingerprintJS.load();
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        const visitorId = result.visitorId;
        console.log('visitorId:', visitorId);

        let url = 'https://cm.ad2iction.com/api/getID.php?fp=';
        if (!ad2udidValue) {
          // 從 cookie 取不到 ad2udid
          url += visitorId;
          makeRequest(url).then((data) => {
            console.log('data with fp:', data);
            setThirdPartyCookie(data.id);
            setFirstPartyCookies(data.id);
            resolve(data.id);
          });
        } else if (!ad2udidValue.includes(visitorId)) {
          // 從 cookie 取得 ad2udid 但為舊版，不含 visitorId (新版 ad2udid 含 visitorId)
          url = url + visitorId + '&uid=' + ad2udidValue; // 傳入舊版 ad2udid
          makeRequest(url).then((data) => {
            console.log('data with fp & uid:', data);
            setThirdPartyCookie(data.id);
            setFirstPartyCookies(data.id);
            resolve(data.id);
          });
        } else {
          // 從 cookie 取得新版 ad2udid (僅回傳不做任何事)
          console.log('resolve ad2udidValue');
          resolve(ad2udidValue);
        }
      });
  });
}

export { getAd2udid };
